<template>
    <div class="vip_home">
        <div class="v1">
            <div class="v1_cont">
                <p class="p1">定制课程</p>
                <p class="p2">VIP院校计划</p>
                <p class="p3">RoSSo专业服务近十年，累计圆梦学生16000+</p>
            </div>
        </div>
        <div class="v2">
            <div class="v2_cont">
                <div class="v2_left">
                    <img src="../img/vip院校计划/Rectangle 1310.jpg" alt="">
                    <div class="v2_kuai1"></div>
                    <div class="v2_kuai2"></div>
                </div>
                <div class="v2_right">
                    <p>
                        <span>
                            VIP院校计划是RoSSo为同学量身定制的 VIP 教学与申请方案。由RoSSo顶尖艺术名校导师、海外艺术名校在职教授、知名艺术院校招生官联合组成的教学、审核团队，全程多对 1 辅导。<br>
                        </span>
                        <span>适合人群：</span>申请艺术设计院校本科、研究生的学生 <br>
                        <span>师资力量：</span>海外艺术家＋英美艺术院校教授 <br>
                        <span>课程内容：</span>创意基础、专业必备技能强化、定制化作品集课程、 offer plus、英文 Critique、海外名校教授 Tutorial、实习推荐等。保证学员获得欧美
                        权威专业(或自选梦校)TOP3、TOP5、TOP8 名校 offer，全面培养学生艺术能力， 使学生与海外高等艺术课程体系无缝衔接。
                    </p>
                    <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })">
                        <div>
                            立即咨询
                            <img src="../img/vip院校计划/Group 703.png" alt="">
                        </div>
                    </a>

                </div>
            </div>
        </div>
        <div class="a4">

            <div class="section_title">
                <span class="section_cn">RoSSo的服务与优势</span>
                <p class="section_en"></p>
            </div>
            <div class="a4_cont">
                <div class="a4_cont_title">
                    RoSSo依据爱德思Art and Design官方考纲，集结海归名校导师，对A Level 艺术科目进行深度教研。依托优质的艺术教育资源和丰富的行业经验，为学生提供专业的国际课程教育。
                </div>
                <div class="a4_main">
                    <div class="a4_main_left">
                        <div class="a4_main_left_item" @click="dotClick(0)" style="font-weight: bold;">
                            <p> </p>
                            <span>RoSSo服务</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(1)">
                            <p> </p>
                            <span>服务流程</span>
                        </div>
                        <div class="a4_main_left_item" @click="dotClick(2)">
                            <p> </p>
                            <span>RoSSo独家优势</span>
                        </div>
                    </div>
                    <div class="a4_main_right">
                        <div class="a4_main_dot">
                            <div class="a4_main_dot_prev" @click="a4prev">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                            <div class="a4_main_dot_next" @click="a4next">
                                <div class="line1"></div>
                                <div class="line2"></div>
                            </div>
                        </div>
                        <div class="a4_main_right_banner" id="a4banner">
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">RoSSo服务</div>
                                <div class="a41_btn_box">
                                    <div class="a41_btn" @click="togglea41btn(0)">本科生 · Undergraduate</div>
                                    <div class="a41_btn" @click="togglea41btn(1)">研究生 · Postgraduate</div>
                                </div>
                                <div class="a41_cont a4_cont_height" ref="a4hegiht">
                                    <div class="a41_item">
                                        <p>LEVEL 1 <br>综合交叉学科基础技 <br>能技法产出1VS1 <br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 2
                                            <br>
                                            创意基础产出
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 3 <br>

                                            专业项目基础
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 4
                                            <br>
                                            专业作品集项目产出
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>独立命题专项指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>教学主管全程监督<br>
                                        </p>
                                    </div>

                                    <div class="a41_item">
                                        <p>Seedo职场导师/<br>研学/公益一次
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>外籍名校教授
                                            <br>一对一项目课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨学科workshop<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>校外展览调研课程<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨学科
                                            <br>专业设备操作
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>专业作品拍摄与修片<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨校区名师指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>排班指导与服务<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>家长海外教育/<br>学生心理必修课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>专属助教导师<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>海外教授
                                            <br>短期项目课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>OFFER PLUS
                                            <br>大学预备课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>Studio Class/<br>竞赛项目
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>在校作业提升指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>软件辅导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>RoSSo周末加油站<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>VIP专属家长会<br>
                                        </p>
                                    </div>
                                </div>
                                <div class="a41_cont2" style="display: none;">
                                    <div class="a41_item2">
                                        <p>专业作品集项目产出<br>+基础补充<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>名师竞赛项目课<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>研究计划书SP<br>/动机信/面试视频拍摄<br>/面试辅导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>教学主管全程监督<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>教务班主任全程监督<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>Seedo职场导师<br>（推荐信）一次<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>外籍名校教授<br>一对一项目课<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>跨学科workshop<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>学术实地调研课程<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>跨学科专业设备操作<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>专业作品拍摄与修片<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>跨校区名师指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>排版指导与服务<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>家长海外教育<br>/学生心理必修课<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>专属助教导师<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>海外教授短期项目课<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>Studio Class<br>/竞赛项目<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>在校作业提升指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>软件辅导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>ROSSO周末加油站<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>VIP专属家长会<br>
                                        </p>
                                    </div>
                                    <div class="a41_item2">
                                        <p>外教模拟面试<br>
                                        </p>
                                    </div>
                                </div>

                            </div>
                            <div class="a4_main_right_item a4_main_right_item2">
                                <div class="a4_main_right_item_title">服务流程</div>

                                <img src="../img//vip院校计划/Group 696.jpg" alt="" ref="a4hegiht"
                                    class="a42_cont a4_cont_height">

                            </div>
                            <div class="a4_main_right_item a4_main_right_item3">
                                <div class="a4_main_right_item_title">RoSSo独家优势</div>
                                <div class="a43_cont a4_cont_height" ref="a4hegiht">
                                    <div class="a43_item">
                                        <img src="../img/vip院校计划/Rectangle 1350.jpg" alt="">
                                        <h1>01. 自研基础课纲</h1>
                                        <p>
                                            ● 根据学生基础定制化教学 <br>
                                            ● 五重审核体系提高课程质量及深度 <br>
                                            ● 四级教学法步步提升<br>
                                        </p>

                                    </div>
                                    <div class="a43_item">
                                        <img src="../img/vip院校计划/Rectangle 1338.jpg" alt="">
                                        <h1>02. 多V1教育系统</h1>
                                        <p>
                                            ● 每位学员配备2-3位老师 <br>
                                            ● 主线老师带专业项目，辅线分软件课老师、基础课手 <br>
                                            &#x3000;绘课老师、跨专业辅导老师<br>
                                            ● 全程1对1可视化教学
                                        </p>

                                    </div>
                                    <div class="a43_item">
                                        <img src="../img/vip院校计划/Rectangle 1353.jpg" alt="">
                                        <h1>03. 申请和规划双把控</h1>
                                        <p>
                                            ● 申请老师，整合学生材料、个人简历、陈述、写作材<br>
                                            &#x3000;料递交等。 <br>
                                            ● 规划老师结合学生学校和家庭资源匹配活动方案，结<br>
                                            &#x3000;合RoSSo内部资源，为学生提供合适的实习机会等。 <br>

                                        </p>

                                    </div>
                                    <div class="a43_item">
                                        <img src="../img/vip院校计划/Rectangle 1352.jpg" alt="">
                                        <h1>04. Offer Plus高校衔接课</h1>
                                        <p>
                                            ● 英美主流大学大一大二以及研一研二的课程大纲 <br>
                                            ● 老师根据大纲提前授课，提前进入国外的授课模式以<br>
                                            &#x3000;及课程了解 <br>

                                        </p>

                                    </div>


                                </div>
                            </div>
                            <div class="a4_main_right_item a4_main_right_item1">
                                <div class="a4_main_right_item_title">RoSSo服务</div>
                                <div class="a41_btn_box">
                                    <div class="a41_btn" @click="togglea41btn(0)">本科生 · Undergraduate</div>
                                    <div class="a41_btn" @click="togglea41btn(1)">研究生 · Postgraduate</div>
                                </div>
                                <div class="a41_cont a4_cont_height" ref="a4hegiht">
                                    <div class="a41_item">
                                        <p>LEVEL 1 <br>综合交叉学科基础技 <br>能技法产出1VS1 <br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 2
                                            <br>
                                            创意基础产出
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 3 <br>

                                            专业项目基础
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>LEVEL 4
                                            <br>
                                            专业作品集项目产出
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>独立命题专项指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>教学主管全程监督<br>
                                        </p>
                                    </div>

                                    <div class="a41_item">
                                        <p>Seedo职场导师/<br>研学/公益一次
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>外籍名校教授
                                            <br>一对一项目课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨学科workshop<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>校外展览调研课程<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨学科
                                            <br>专业设备操作
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>专业作品拍摄与修片<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>跨校区名师指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>排班指导与服务<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>家长海外教育/<br>学生心理必修课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>专属助教导师<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>海外教授
                                            <br>短期项目课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>OFFER PLUS
                                            <br>大学预备课
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>Studio Class/<br>竞赛项目
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>在校作业提升指导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>软件辅导<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>RoSSo周末加油站<br>
                                        </p>
                                    </div>
                                    <div class="a41_item">
                                        <p>VIP专属家长会<br>
                                        </p>
                                    </div>
                                </div>
                                <div class="a41_cont2" style="display: none;">
                                    <div class="a41_item2">
                                        <p>LEVEL 1 <br>综合交叉学科基础技 <br>能技法产出1VS1 <br>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="v3">
            <div class="v3_cont">

                <div class="swiper mySwiperV1">

                    <div class="v3_title">
                        <p>国际师资团队 >></p>
                        <div class="v3_btn" @click="toggleV3(0)">#海外教授</div>
                        <div class="v3_btn" @click="toggleV3(1)">#海归导师</div>
                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in teacherData">
                            <div class="v3_item" v-for="(item2, index2) in item" @click="teacherDetail(item2.id)">
                                <div class="img_box">
                                    <img :src="'https://public.rossoarts.com/static/uploads/teacher/' + item2.avatar"
                                        alt="">
                                </div>
                                <span class="p1">{{ item2.school | schoolAll }}</span>
                                <h2>{{ item2.name | fliterName }}</h2>
                                <p class="p2">{{ item2.major }}</p>
                                <p class="p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>

                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>

            </div>

        </div>

        <div class="v4">
            <div class="v3_cont">

                <div class="swiper mySwiperV1">

                    <div class="v3_title">
                        <p>最新录取案例 >></p>
                        <div>#2023年</div>

                    </div>
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <div class="v4_item">
                                <img src="../img/vip院校计划/1.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/2.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/3.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/4.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                        </div>
                        <div class="swiper-slide">
                            <div class="v4_item">
                                <img src="../img/vip院校计划/5.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/6.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/7.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                            <div class="v4_item">
                                <img src="../img/vip院校计划/8.jpg" alt="" class="larger_img" @click="imgCover($event)">
                            </div>
                        </div>


                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>

            </div>

        </div>
        <div class="section_inp" style="margin-top: 180px;">
            <div class="s_inp_left">
                <img src="../img/shouchahua.png" alt="" class="img_shou  wow rotateInDownLeft" id="imgShou">
                <img src="../img/vip院校计划/Group 708.png" alt="" class="img_text  wow rollIn" id="imgText" style="margin-left:-10px">
            </div>
            <div class="s_inp_right">
                <el-form :inline="true" :label-position="labelPosition" label-width="150px" :model="formLabelAlign">
                    <el-form-item label="姓名：">
                        <el-input v-model="formLabelAlign.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="意向专业：" class="elitem2">
                        <el-select v-model="formLabelAlign.region" placeholder="选择意向专业">
                            <el-option label="服装设计" value="服装设计"></el-option>
                            <el-option label="景观设计" value="景观设计"></el-option>
                            <el-option label="工业设计" value="工业设计"></el-option>
                            <el-option label="插画设计" value="插画设计"></el-option>
                            <el-option label="动画设计" value="动画设计"></el-option>
                            <el-option label="建筑设计" value="建筑设计"></el-option>
                            <el-option label="交互设计" value="交互设计"></el-option>
                            <el-option label="室内设计" value="室内设计"></el-option>
                            <el-option label="其他" value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="电话：">
                        <el-input v-model="formLabelAlign.tel" placeholder="请输入电话号码"></el-input>
                    </el-form-item>
                    <el-form-item label="意向国家：" class="elitem2">
                        <el-select v-model="formLabelAlign.region2" placeholder="选择意向国家">
                            <el-option label="英国" value="England"></el-option>
                            <el-option label="美国" value="America"></el-option>
                            <el-option label="日本" value="Japan"></el-option>
                            <el-option label="新加坡" value="Singapore"></el-option>
                            <el-option label="韩国" value="Korea"></el-option>
                            <el-option label="欧洲" value="Europe"></el-option>

                            <el-option label="其他" value="Other"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="意向专业：">
                    <el-input v-model="formLabelAlign.major" placeholder="请输入意向专业"></el-input>
                </el-form-item> -->
                    <el-form-item class="yuyue_box">
                        <div class="yuyue" @click="onSubmit()"></div>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <!-- 最外层div -->
    </div>
</template>
<script>
var _self
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import axios from "axios"
import "@/assets/css/vip.css"
export default {
    data() {
        return {
            a4i: 0,
            teacherData: [],
            category: 2,
            formLabelAlign: {
                name: '',
                tel: '',
                region: '',
                region2: '',
                major: '',
            },
            labelPosition: 'right',
        }
    },
    beforeCreate() {
        _self = this;
    },
    filters: {
        fliterName(val) {
            // console.log(val, _self.category);
            return _self.category == 1 ? val : "Prof." + val
        },
        schoolAll(val) {
            return val.split(",")[1]
        },
        schoolSplit(val) {
            return val.split(",")[0]
        },
    },
    created() {
        this.getTeacherData()
    },
    methods: {
        teacherDetail(val) {
            this.$router.push(`/teachers/${val}.html`)
        },
        imgCover(e) {
            // var img = document.getElementsByTagName("img")
            var coverBlack = document.getElementById("coverBlack")
            var larger_img = document.getElementsByClassName("larger_img")
            // console.log();
            coverBlack.style.display = "block"
            coverMainImg.src = e.target.src
            coverMainImg.style.width = "30%"
            // console.log(img);
            // console.log(e.target.src);

        },
        onSubmit() {
            var currentURL = window.location.href;
            var status = ''
            // 检查 URL 中是否包含某些关键词，来判断使用的搜索引擎
            if (currentURL.includes("google")) {
                status = "用户正在使用 Google 搜索引擎"
            } else if (currentURL.includes("bing")) {
                status = "用户正在使用 Bing 搜索引擎"
            } else if (currentURL.includes("yahoo")) {
                status = "用户正在使用 Yahoo 搜索引擎"
            } else if (currentURL.includes("baidu")) {
                status = "用户正在使用 百度 搜索引擎"
            } else {
                status = "无法确定用户使用的搜索引擎"
            }
            // console.log('submit!',this.formInline);
            var patt = /^1[3-9][0-9]{9}$/

            if (this.formLabelAlign.name == "" || this.formLabelAlign.tel == "") {
                // console.log("姓名和手机号不能为空");
                this.$message.error('姓名和手机号不能为空');

            } else {
                // console.log("不是空");

                if (patt.test(this.formLabelAlign.tel)) {

                    // console.log("可以发请求");
                    // console.log(this.formInline);
                    axios.post("https://public.rossoarts.com/index/common/getform", {
                        "name": this.formLabelAlign.name,
                        "tel": this.formLabelAlign.tel,
                        "major": this.formLabelAlign.major,
                        "intended_country":this.formLabelAlign.region2,
                        "url": window.location.href,
                        "status":status,
                    }).then((data) => {
                        console.log(data, "response");
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    }).catch(function (error) {
                        console.log(error, "error");
                    });

                } else {
                    console.log("手机号格式不正确");
                    this.$message.error('手机号格式不正确');

                }

            }


        },
        toggleV3(val) {
            // console.log(val);
            var v3_btn = document.getElementsByClassName("v3_btn")
            for (var i = 0; i < v3_btn.length; i++) {
                v3_btn[i].style.color = "#000"
                v3_btn[i].style.borderColor = "#000"
            }
            v3_btn[val].style.color = "#FB6333"
            v3_btn[val].style.borderColor = "#FB6333"
            if (val == 0) {
                this.category = 2
            } else {
                this.category = 1
            }
            this.getTeacherData()
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getTeacherData() {
            axios.get(`https://public.rossoarts.com/api/v1/getFirstTeacher?category=${this.category}&limit=12`).then((data) => {
                // console.log(data.data);
                this.teacherData = this.arrGroup(data.data, 4)
                // console.log(this.teacherData);
                this.$nextTick(() => {
                    this.mySwiperV1Init()
                })
            })
        },
        mySwiperV1Init() {
            new Swiper('.mySwiperV1', {
                loop: true,
                observe: true,
                observeParents: true,
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            })
        },

        togglea41btn(val) {
            var a41_cont = document.getElementsByClassName("a41_cont")
            var a41_cont2 = document.getElementsByClassName("a41_cont2")
            var a41_btn = document.getElementsByClassName("a41_btn")
            if (val == 0) {
                a41_cont[0].style.display = "flex"
                a41_cont2[0].style.display = "none"

            } else {
                a41_cont2[0].style.display = "flex"
                a41_cont[0].style.display = "none"

            }
            for (var i = 0; i < a41_btn.length; i++) {
                a41_btn[i].style.color = "#000"
                a41_btn[i].style.borderColor = "#000"
            }
            a41_btn[val].style.color = "#FB6333"
            a41_btn[val].style.borderColor = "#FB6333"
        },
        dotClick(val) {
            console.log(val);
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            var a4_cont_height = document.getElementsByClassName("a4_cont_height")
            var a4_main_right = document.getElementsByClassName("a4_main_right")
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[val].style.fontWeight = "bold"
            this.a4i = val
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`


            a4banner.style.height = $(".a4_cont_height").eq(this.a4i).height() + 180 + "px"
            // console.log($(".a4_cont_height").eq(val).height(), "0718");
        },
        a4next() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            // var a4_main_right_item = document.getElementsByClassName("a4_main_right_item")
            this.a4i++;
            // console.log(a4_main_right_item[this.a4i]);
            // a4banner.style.height = a4_main_left_item[this.a4i].style.height
            a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            a4banner.style.transition = 'all .36s'
            if (this.a4i == 3) {
                this.a4i = 0;
                setTimeout(() => {
                    a4banner.style.transform = 'translate(0,0)';
                    a4banner.style.transition = 'none'
                }, 360);

            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height = $(".a4_cont_height").eq(this.a4i).height() + 180 + "px"
        },
        a4prev() {
            var a4_main_left_item = document.getElementsByClassName("a4_main_left_item")
            this.a4i--;
            if (this.a4i == -1) {
                this.a4i = 2;//length - 1

                a4banner.style.transition = 'none'

                a4banner.style.transform = `translateX(${-915 * (this.a4i + 1)}px)`
                setTimeout(() => {
                    a4banner.style.transform = 'translateX(' + (-this.a4i * 915) + 'px)';
                    a4banner.style.transition = 'all .36s'
                }, 1);

            } else {
                a4banner.style.transition = 'all 0.36s'
                a4banner.style.transform = `translateX(${-915 * this.a4i}px)`
            }
            for (var i = 0; i < a4_main_left_item.length; i++) {
                a4_main_left_item[i].style.fontWeight = "400"
            }
            a4_main_left_item[this.a4i].style.fontWeight = "bold"
            a4banner.style.height = $(".a4_cont_height").eq(this.a4i).height() + 180 + "px"
            // console.log($(".a4_cont_height").eq(this.a4i).height(), "0718",this.a4i);
        },
    },
    mounted() {
        // this.mySwiperV1Init()
    },

}
</script>